/* beautiful-react-hooks version: 0.31.1 */
import { useCallback } from 'react';
import debounce from 'lodash.debounce';

var defaultOptions = {
  leading: false,
  trailing: true
};

var useDebouncedFn = function useDebouncedFn(fn) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOptions;
  var dependencies = arguments.length > 3 ? arguments[3] : undefined;
  var debounced = debounce(fn, wait, options);
  return useCallback(debounced, dependencies);
};

export default useDebouncedFn;
